<div class="scanner-shell" [hidden]="!hasDevices">
  <mat-menu #appMenu="matMenu">
    <mat-selection-list>
      <mat-list-option checkboxPosition="start" (click)="toggleTryHarder()" [selected]="tryHarder">
        Enable Try-harder
      </mat-list-option>
      <mat-list-option checkboxPosition="start" (click)="toggleTorch()" [selected]="torchEnabled"
                       *ngIf="torchAvailable$ | async">
        Enable Torch
      </mat-list-option>
    </mat-selection-list>
    <mat-divider></mat-divider>
    <button mat-menu-item (click)="openFormatsDialog()">Barcode formats</button>
    <button mat-menu-item (click)="openInfoDialog()">App info</button>
  </mat-menu>

  <header>
    <mat-form-field appearance="fill">
      <select matNativeControl matInput (change)="onDeviceSelectChange($event.target.value)">
        <option value="" [selected]="!currentDevice">No Device Selected</option>
        <option *ngFor="let device of availableDevices" [value]="device.deviceId"
                [selected]="currentDevice && device.deviceId === currentDevice.deviceId">{{device.label}}</option>
      </select>
    </mat-form-field>
    <button type="button" class="close w-25" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true" class="btn btn-danger">Back</span>
    </button>
  </header>
  <div *ngIf="!qrResultString">
    <div class="row mx-0 my-2">
    <div class="col-9"> <input type="text" [(ngModel)]="enterString" placeholder="Enter {{labelName}} Manually" class="form-control"/></div>
    <div class="col-3">  <button type="button" class="btn btn-primary" (click)="onCodeResult(enterString)" [disabled]="!enterString.trim()">Submit</button></div>
    </div>
    <label class="ml-3">Scan QR Code</label>
    <zxing-scanner  [torch]="torchEnabled" [(device)]="currentDevice" (scanSuccess)="onCodeResult($event)"
                    [formats]="formatsEnabled" [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)"
                    (camerasFound)="onCamerasFound($event)" (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>
  </div>

  <section class="results" *ngIf="qrResultString">
    <div>
      <small>Result</small>
      <strong>{{ qrResultString }}</strong>
    </div>
    <button mat-icon-button (click)="clearResult()">&times;</button>
  </section>

</div>
<div class="p-4">

  <ng-container *ngIf="hasPermission === undefined">

    <h2>Waiting for permissions.</h2>

    <blockquote>
      If your device does not has cameras, no permissions will be asked.
    </blockquote>

  </ng-container>

  <ng-container *ngIf="hasPermission === false">

    <h2>You denied the camera permission, we can't scan anything without it. 😪</h2>

  </ng-container>

  <ng-container *ngIf="hasDevices === undefined">

    <h2>Couldn't check for devices.</h2>

    <blockquote>
      This may be caused by some security error.
    </blockquote>

    <div class="row mx-0 my-2">
      <div class="col-9"> <input type="text" [(ngModel)]="enterString" placeholder="Enter {{labelName}} Manually" class="form-control"/></div>
      <div class="col-3">  <button type="button" class="btn btn-primary" (click)="onCodeResult(enterString)" [disabled]="!enterString.trim()">Submit</button></div>
    </div>

  </ng-container>

  <ng-container *ngIf="hasDevices === false">

    <h2>No devices were found.</h2>

    <blockquote>
      I believe your device has no media devices attached to.
    </blockquote>

  </ng-container>
</div>
